function getScrollPercent() {
    var h = document.documentElement, 
        b = document.body,
        st = 'scrollTop',
        sh = 'scrollHeight';
    return (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100;
}

var floating_box = document.querySelector('.floating-box');

setInterval(function() {
    floating_box.style.top = -(6 * getScrollPercent()) + 'px';
}, 10);